import React from "react"
import types from "prop-types"
import { withFormsy } from "formsy-react"
import MultiSelect from "shared/multiSelects/MultiSelect"

const optionsFromList = (options) => options.map((opt) => ({ label: opt.title, value: opt.id }))

const MultiFormSelect = ({
  name = "",
  className = "",
  value = undefined,
  options = [],
  onChange,
  ...rest
}) => (
  <MultiSelect
    className={className}
    name={name}
    options={optionsFromList(options)}
    value={value}
    onChange={onChange}
    {...rest}
  />
)

MultiFormSelect.propTypes = {
  name: types.string,
  onChange: types.func.isRequired,
  options: types.arrayOf(types.object),
  value: types.arrayOf(types.number),
  className: types.string,
}

export const FormsyMultiFormSelect = withFormsy(({ setValue, ...rest }) => (
  <MultiFormSelect onChange={setValue} {...rest} />
))

FormsyMultiFormSelect.displayName = "FormsyMultiFormSelect"

export default MultiFormSelect
